import { Component } from '@angular/core';

@Component({
  selector: 'app-logo-circle',
  templateUrl: './logo-circle.component.html',
  styleUrl: './logo-circle.component.scss'
})
export class LogoCircleComponent {

}
